import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=0a232e2e&scoped=true"
import script from "./RoleUserList.vue?vue&type=script&lang=js"
export * from "./RoleUserList.vue?vue&type=script&lang=js"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=0a232e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a232e2e",
  null
  
)

export default component.exports